import { useMemo } from "react";
import Form from "react-bootstrap/Form";
import "./tenantStyles.css";
import { TextCss } from "../GlobalCss/TextCss";
import { sortOptionsAlphabeticallyOtherLast } from "../../utils/helper";

function NewSelectAuto({
  data,
  disabled,
  setDisabled,
  selected,
  setSelected,
  title,
  type = "Option",
  setResetDependencies = null,
  error,
  setError,
  fromContractor = false,
  label = "",
  width = "298px",
  setSelectedOption = null,
  selectedOption = null,
  errorMessage = undefined,
  required=undefined
}) {
  const getLabel = (item) =>
    type === "property" ? item?.name : type === "unit" ? item?.unitNumber : item?.name;

  const sortedData = useMemo(
    () => sortOptionsAlphabeticallyOtherLast(data ?? [], getLabel),
    [data, type],
  );

  const handleChange = (e) => {
    setError(false);
    if (setResetDependencies) {
      setResetDependencies([]);
    }
    setSelected && setSelected(Number(e.target.value));
    if (setSelectedOption) {
      setSelectedOption(e.target.options[e.target.selectedIndex].text);
    }
  };

  return (
    <div
      style={{ width: width }}
      title={disabled ? title : ""}
      className={
        disabled
          ? " customEditTenantInputContainerStyles disabled"
          : "customEditTenantInputContainerStyles d-flex flex-cloumn gap-2 flex-column"
      }
    >
      {/* {fromContractor && (
        <div> */}
        {label &&
          <p className={`${label ? TextCss.black.sub_heading_600_14 : ""} `}>{label}{required && <span className="red">*</span>}</p>
        } {/* </div>
      )} */}

      <Form.Select
        className={disabled ? "disabled FormSelectCustom" : "FormSelectCustom"}
        onChange={handleChange}
        aria-label="Default select example"
        style={{
          color:
            selected === undefined || selected === null
              ? "var(--Grey-Subtext2)"
              : "var(--Grey-Heading)",
          border: error
            ? "1px solid #F05252"
            : "1px solid var(--Grey-Divider)",
        }}
        // value={selected || ""}
        value={selected !== undefined && selected !== null ? selected : ""}
      >
        {/* hidden: Chrome paints disabled options in the open list with its own grey, ignoring
            author colors, so in dark mode this placeholder was unreadable (QA Sep row 140). The
            closed select still shows it while nothing is selected. */}
        <option value="" disabled hidden>{`Select ${type}`}</option>

        {sortedData && sortedData.length > 0 ? (
          sortedData.map((item) => (
            <option key={item?.id} value={item?.id}>
              {type === "property"
                ? item?.name
                : type === "unit"
                  ? item?.unitNumber
                  : item?.name}
            </option>
          ))
        ) : (
          <option disabled>No {type} listed</option>
        )}
      </Form.Select>
      {error && <p className="errorMessage">{errorMessage}</p>}
    </div>
  );
}

export default NewSelectAuto;
